import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPersonProfileFilledStyle0 = cosmosIconCss;

const CosmosIconPersonProfileFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPersonProfileFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1ad5b26efb01158c0e0c786bbb460a42d49e285e', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '65a8b00f68318747022b0a3f67c8f3269181a343', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '196cb62801597cf9709c9b851abffe1e06d5ee84', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.14 3.89a2.79 2.79 0 0 0-.58 2.33L8 9.46A2.84 2.84 0 0 0 11 12a2.83 2.83 0 0 0 3-2.55l.4-3.22a2.77 2.77 0 0 0-.58-2.35A3.66 3.66 0 0 0 11 2.78a3.7 3.7 0 0 0-2.86 1.11Zm7.61 7.88a.51.51 0 0 0-.59.21A4.94 4.94 0 0 1 11 14a5 5 0 0 1-4.16-2 .5.5 0 0 0-.58-.21 10.8 10.8 0 0 0-2.64 1.37.5.5 0 0 0-.16.62l2.32 5a.51.51 0 0 0 .46.29h9.52a.51.51 0 0 0 .46-.29l2.32-5a.5.5 0 0 0-.16-.62 11.28 11.28 0 0 0-2.63-1.39ZM13.5 16.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPersonProfileFilledStyle0; }
}, [1, "cosmos-icon-person-profile-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-person-profile-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-person-profile-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPersonProfileFilled$1);
            }
            break;
    } });
}

const CosmosIconPersonProfileFilled = CosmosIconPersonProfileFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPersonProfileFilled, defineCustomElement };
